import Wix from './wix-sdk-polyfill-lazy';
import { getLanguage } from './i18n';

export function requestLogin() {
  return Wix().requestLogin({
    language: getLanguage(),
    checkCommunityCheckbox: true,
    modal: true,
  });
}
